<template>
  <div style="padding: 10px 15px 0 15px">
    <div class="card search-box" style="border-bottom: 1px solid #eee">
      <div style="display: flex; flex-wrap: wrap">
        <div style="margin-right: 10px; margin-bottom: 10px">
          <span style="font-size: 14px; margin-right: 10px">productCode:</span>
          <el-input v-model="searchQuery.productCode" clearable style="width: 180px"></el-input>
        </div>
        <div style="margin-right: 10px; margin-bottom: 10px">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="
              searchQuery.pageNo = 1;
              getTableData();
            "
            style="margin-left: 30px"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="card search-box">
      <div style="margin: 10px 0">
        <el-button type="primary" @click="exportFile()">导出</el-button>
        <el-button type="primary" @click="batchDelete()">批量删除</el-button>
        <el-button style="float: right" type="text" @click="downloadTemplate">{{ $t('common.download', ['']) }}{{ $t('common.template') }}</el-button>
        <el-upload
          ref="uploadBox"
          style="float: right"
          class="upload-demo"
          :file-list="payCertificate"
          :limit="1"
          :http-request="handleHttpRequest"
          :on-change="uploadfilechange"
          accept=".xls,.xlsx"
          :on-success="handleSuccess"
          :on-remove="onRemove"
          :on-exceed="onExceed"
          :show-file-list="false"
        >
          <el-button size="small" type="primary">导入</el-button>
        </el-upload>
      </div>
    </div>
    <div class="card">
      <el-table :data="tableData" @selection-change="tableSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="productCode" label="productCode" min-width="120px"></el-table-column>
        <el-table-column prop="designerId" label="designid" min-width="120px"> </el-table-column>
        <el-table-column prop="colorCode" label="colorCode" min-width="110px"></el-table-column>
        <el-table-column align="left" prop="action" label="操作" width="160px" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" type="danger" @click="removeRecord(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchQuery.pageNo"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="searchQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="padding-top: 10px; text-align: right"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getSpecialProductList, deletetSpecialProduct, importSpecialProduct, exportSpecialProduct } from '../../api/product';
import { uploadImg } from '../../api/logistics';
import { downloadBlobFile, downloadUrlFile } from '../../common/utils';

export default {
  data() {
    return {
      current: 0,
      tableData: [],
      total: 0,
      searchQuery: {
        pageSize: 25,
        pageNo: 1,
        productCode: '',
      },
      selection: [],
      fileList: [],
      payCertificate: [],
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    async handleHttpRequest(option) {
      const file = option.file;
      const fd = new FormData();
      fd.append('file', file);
      fd.append('directoryPath', 'tmp');
      return uploadImg(fd);
    },
    uploadfilechange(file, fileList) {
      this.payCertificate = [];
      this.payCertificate = fileList;
    },
    handleSuccess(res, file, fileList) {
      if (res.success && res.data && res.data.ossUrl) {
        importSpecialProduct({ url: res.data.ossUrl }).then((res) => {
          if (res.success && res.code == 1) {
            this.$message.success('导入成功');
            this.getTableData();
          } else if (res.success && res.code == 1002 && res.data) {
            this.$message.error('导入失败，自动下载文件解析结果');
            downloadUrlFile(res.data);
          }else  {
            this.$message.error(res.message || '导入失败');
          }
        });
      } else {
        this.$message.error(res.message || '导入失败');
      }
    },
    onExceed(files, fileList) {
      this.$set(fileList[0], "raw", files[0]);
      this.$set(fileList[0], "name", files[0].name);
      this.$refs["uploadBox"].clearFiles(); //清除文件
      this.$refs["uploadBox"].handleStart(files[0]); //选择文件后的赋值方法
      this.$refs["uploadBox"].submit(); //上传文件
    },
    onRemove(file, fileList) {
      this.payCertificate = fileList;
      this.$emit('update:payCertificate', fileList);
    },
    tableSelectionChange(selection) {
      this.selection = selection;
    },
    handleSizeChange(size) {
      this.searchQuery.pageSize = size;
      this.getTableData();
    },
    handleCurrentChange(index) {
      this.searchQuery.pageNo = index;
      this.getTableData();
    },
    getTableData() {
      let searchQuery = { ...this.searchQuery };
      getSpecialProductList(searchQuery).then((res) => {
        this.total = res.data.total;
        this.tableData = res.data.list;
      });
    },
    removeRecord(row) {
      this.$msgbox({
        title: '删除',
        message: '确认删除当前记录吗',
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.deletetSpecialProduct([row.productCode]);
      });
    },
    batchDelete() {
      if (!this.selection.length) {
        this.$message.error('请勾选数据！');
        return;
      }
      let productCodeList = this.selection.map((item) => item.productCode);
      this.deletetSpecialProduct(productCodeList);
    },
    deletetSpecialProduct(params) {
      deletetSpecialProduct(params).then((res) => {
        if (res.success) {
          this.$message.success('操作成功');
          this.getTableData();
        } else {
          this.$message.error('操作失败');
        }
      });
    },
    exportFile() {
      exportSpecialProduct().then((res) => {
        if (res.url) {
          downloadUrlFile(res.url);
        } else {
          this.$message.error(res.message || '导出失败');
        }
      });
    },
    downloadTemplate() {
      var url  = 'http://product-sts.oss-cn-shanghai.aliyuncs.com/upload/导入特例商品-模板.xlsx'
      if (!url) {
        return;
      }
      const protocol = window.location.protocol;
      if (protocol === 'https:') {
        url = url.replace('http://', 'https://');
      }
      if (url.toLowerCase().endsWith('.pdf')) {
        Vue.axios({
          url,
          responseType: 'blob',
        }).then((res) => {
          downloadBlobFile(res.data, '导入特例商品-模板.xlsx');
        });
      } else {
        window.open(url);
      }
    },
  },
  created() {},
};
</script>
